import { colors } from './colors';

export const shadows = {
  inputOutlined: `0 0 0 30px ${colors.background?.default} inset !important`,
  inputFilled: `0 0 0 30px ${colors.grey?.[100]} inset !important`,
};
